import { render, staticRenderFns } from "./casesDiagnosis.vue?vue&type=template&id=07e0034e&scoped=true"
import script from "./casesDiagnosis.vue?vue&type=script&lang=js"
export * from "./casesDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./casesDiagnosis.vue?vue&type=style&index=0&id=07e0034e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e0034e",
  null
  
)

export default component.exports